<template>
  <div class="acknowledgement">
    <h4>{{ heading }}</h4>
    <p><slot /></p>
  </div>
</template>

<script>
export default {
  name: "Acknowledgement",
  props: {
    heading: String
  }
};
</script>

<style lang="scss" scoped>
.acknowledgement {
  padding: 0 8px;

  h4 {
    margin-bottom: 0px;
  }

  p {
    margin-top: 5px;
    padding: 0 4px;
  }
}
</style>
